<template>
    <div class="main-data-tabledata">
        <el-button style="text-align: left;margin-top:-15px;" icon="el-icon-search" type="primary" @click="handleFilterCondition()">筛选条件</el-button>
        <DynamicTable
            ref="dynamicTable"
            :showSummary="showSummary"
            :tableColumns="tableColumns"
            :fieldsList="fieldsList"
            :subformTableColumns="subformTableColumns"
            :tableData="pageData"
            :pager="page"
            :isLoading="tableLoading"
            :isShowCheckbox="false"
            :isSortable="true"
            :isColumnDrop="true"
            :isSubform="isSubform"
            :isShowPageSizes="true"
            :isShowOverflowTooltip="isShowOverflowTooltip"
            :tableHeight="tableHeight"
            :autoHeight="false"
            :isShowProcessInfo="isShowProcessInfo"
            :isViewApprovalInfo="isViewApprovalInfo"
            :key="time"
            :approvalList="approvalList"
            @filterChange="chooseApprovalStatusField"
            @rowClick="handelSelectRow"
            @changePageSize="queryFormDataByPageSize"
            @changePage="queryFormData"
            @searchOrderby="searchOrderby"
            @selectionChange="selectMore">
        </DynamicTable>
        <el-dialog
            title="设置查询条件"
            append-to-body
            top="4vh"
            :visible.sync="isShowSearchConditon">
            <SearchCondition  v-if="isShowSearchConditon" ref="searchConditon" :conditionFields="conditionFields"  :isShowLeftModel="false"  @chooseSearchConditon="chooseSearchConditon"  />
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowSearchConditon = false">取 消</el-button>
                <el-button @click="resetSearchConditon">重置</el-button>
                <el-button type="primary" @click="chooseSearchConditon">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {getFormFieldListByIds, getApplicationModelDetail, getModelFormReportList, getModelFormInstanceById, getRefHisProcessData} from '@/data-model';
import { clone, cloneDeep } from 'lodash';
import { getUUID } from '@/utils/grocer';
export default{
    components: {

    },
    props: {
        isUpdHis: {// 是否是修改历史数据
            type: Boolean,
            default: false
        },
        isApprovalFilter: {// 是否是限制发起审批的数据，（例如借款，有逾期未还，不让发起审批）
            type: Boolean,
            default: false
        },
        modelId: {
            type: String
        },
        tableHeight: {
            type: String
        },
        taskDefinitionKey: {
            type: String
        },
        processServiceId: {
            type: String
        },
        processInstanceId: {
            type: String
        }
    },
    data () {
        return {
            isShowSearchConditon: false,
            isRefreshCondition: false,
            conditionFields: [],
            selectFormData: [],
            modelObj: {},
            selectedModel: {},
            showSummary: false, // 是否要显示求和
            tableColumns: [],
            fieldsList: [],
            subformTableColumns: [],
            pageData: [],
            page: {
                currentPage: 1, // 当前页码
                pageSize: 10, // 每页条数
                totalPageNum: 1 // 总页数
            },
            tableLoading: false,
            isModelForm: false, // 是否模型表单
            isSubform: false, // 是否包含子表单
            isShowOverflowTooltip: true,
            isShowProcessInfo: false, // 是否显示流程
            isViewApprovalInfo: false, // 是否显示审批状态和审批详情
            time: new Date().getTime(),
            approvalList: [],
            searchParams: {
                modelId: '',
                name: '',
                selectedFields: '',
                searchCondition: [],
                selectedApprovalStatus: ''
            }
        };
    },
    created () {
        if (this.modelId) {
            this.getApplicationModelDetail().then(res => {
                this.renderFormList(this.modelObj, true);
            });
        }
    },
    methods: {
        async getApplicationModelDetail () {
            let modelObj = await getApplicationModelDetail(this.modelId);
            this.modelObj = modelObj;
            this.selectedModel = modelObj;
        },
        queryFormData ({currentPage}) {
            this.isInit = false;
            this.page.currentPage = currentPage;
            this.renderFormList(this.modelObj);
        },
        async renderFormList (model, isInitSearch) {
            this.destoryTable = true;
            if (model && model.modelType > 1) {
                this.isModelForm = false;
            } else {
                this.isModelForm = true;
            }
            this.tableColumns = [];
            this.fieldsList = [];
            this.isSubform = false;
            this.tableLoading = true;
            if (this.isApprovalFilter) {
                this.searchParams.approvalFilterRequest = true;
            }
            this.searchParams.modelId = model.id;
            this.searchParams.formId = model.formId;
            this.searchParams.modelType = model.modeType;
            this.searchParams.isFilterDuplicateData = true;
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let formData = await getModelFormReportList(Object.assign({}, {
                currentPage: this.page.currentPage,
                pageSize: this.page.pageSize
            }, this.searchParams));
            loading.close();
            this.pageData = [];
            if (formData.data) {
                let tableDatas = [];
                formData.data.forEach(item => {
                    let jsonObj = JSON.parse(item);
                    tableDatas.push(jsonObj);
                });
                this.pageData = tableDatas;
            }
            if (formData.otherData.tableColumns) {
                this.tableColumns = [];
                let _tableColumns = formData.otherData.tableColumns;
                this.allTableColumns = cloneDeep(_tableColumns);
                _tableColumns.forEach(item => {
                    if (item.type !== 'divider') { // 隐藏分割线
                        this.tableColumns.push(item);
                    }
                });
            }
            if (formData.otherData.fieldsList) {
                this.fieldsList = formData.otherData.fieldsList;
            }
            if (isInitSearch) {
                this.$emit('refreshSearchConditon', this.tableColumns);
            }
            this.subformTableColumns = formData.otherData.subformTableColumns;
            if (this.isInit) {
                this.isApprovalForm = formData.otherData.isApprovalForm;
            }
            if (formData.otherData.approvalList) {
                this.approvalList = formData.otherData.approvalList;
            }
            this.isShowDown = formData.otherData.isShowDown;
            if (this.$refs.dynamicTable) {
                this.$refs.dynamicTable.setMergeSpanArr(this.pageData);
            }
            this.isSubform = this.getIfSubform(formData.otherData.tableColumns);
            this.page = {
                currentPage: formData.currentPage,
                pageSize: formData.pageSize,
                totalPageNum: formData.totalPageNum
            };
            this.tableLoading = false;
            this.filterSumTableColumns();
            this.time = new Date().getTime();
        },
        async chooseApprovalStatusField (approvalStatus) {
            this.searchParams.selectedApprovalStatus = approvalStatus;
            this.queryFormData(1);
        },
        async handelSelectRow (params) { // 选择的数据
            // if (this.isUpdHis) { // 先检查引用的历史数据是否被引用并处于正在进行中的流程
            //     let hisData;
            //     let loading;
            //     try {
            //         loading = this.$loading({
            //             lock: true,
            //             text: 'Loading',
            //             spinner: 'el-icon-loading',
            //             background: 'rgba(0, 0, 0, 0.7)'
            //         });
            //         hisData = await getRefHisProcessData({taskId: this.taskDefinitionKey, modelInstanceId: params.row.id, processServiceId: this.processServiceId});
            //         loading.close();
            //     } catch (error) {
            //         loading.close();
            //         this.$message({
            //             duration: 3000,
            //             message: '当前数据已经被其它流程引用了，对应流程还未结束的情况下当前数据不能被重复引用,请联系管理员处理',
            //             type: 'warning'
            //         });
            //         return;
            //     }
            //     if (hisData && hisData.processInstanceName && hisData.processInstanceId !== this.processInstanceId) { // 不是同一个流程下
            //         this.$message({
            //             duration: 3000,
            //             message: '当前数据已经被流程【' + hisData.processInstanceName + '】引用了，对应流程还未结束的情况下当前数据不能被重复引用',
            //             type: 'warning'
            //         });
            //         return;
            //     }
            // }
            if (this.isModelForm) {
                this.formInfo = await getModelFormInstanceById(params.row.id);
                await this._dealFormData();
                // console.log(this.selectFormData);
                this.selectFormData.sourceAppDataId = params.row.id;
                this.$emit('reloadFormData', this.selectFormData);
            }
        },
        queryFormDataByPageSize ({pageSize}) {
            this.isInit = false;
            this.page.pageSize = pageSize;
            this.renderFormList(this.modelObj);
        },
        searchOrderby (searchItem) {
            this.searchParams.searchCondition = [];
            this.searchParams.searchCondition.push(searchItem);
            this.queryFormData(1);
        },
        selectMore (params) {
            this.isHasUNDel = params.isHasUNDel;
            this.moreIds = params.ids;
            this.unDelNums = params.unDelNums;
        },
        getIfSubform (tableColumns) {
            let isSubform = false;
            for (var i = 0; i < tableColumns.length; i++) {
                if (tableColumns[i].subcolumn) {
                    isSubform = true;
                    break;
                }
            }
            return isSubform;
        },
        filterSumTableColumns () { // 过滤出需要求和的字段list
            this.isCanShowSummery = false;
            this.hasLinkField = false;
            this.tableColumns.forEach((mainItem, index) => {
                if (mainItem.type === 'number' || mainItem.type === 'calculation') {
                    this.isCanShowSummery = true;
                }
                if (mainItem.type === 'subform') {
                    let subColumns = mainItem.subColumns;
                    subColumns.forEach((subItem) => {
                        if (subItem.type === 'number' || subItem.type === 'calculation') {
                            this.isCanShowSummery = true;
                        }
                    });
                }
                if (mainItem.type === 'link') {
                    this.hasLinkField = true;
                }
            });
        },
        /** 自定义表单的配置信息，动态生产表单双向绑定所需的数据结构 */
        async _dealFormData () {
            let objModelFormData = await this._getModelFormData();
            this.selectFormData = {};
            if (objModelFormData) {
                this.collapseActiveName = objModelFormData.formId;
                let attributes = this.getAttributes(this.formInfo.formObj.structure);// 初始化数据字段结构
                objModelFormData.attributes = attributes;
                //= =========解决新增多选组件，历史数据无法使用该组件的问题begin===========
                let values = clone(objModelFormData.values);
                if (this.isUpdHis) {
                    // 引用数据，用于修改历史流程数据
                    // console.log(values);
                } else {
                    values.id = '';// id置为null
                    for (let prop in attributes) { // 遍历map
                        if (attributes.hasOwnProperty(prop)) {
                            if (attributes[prop] === 'category' || attributes[prop] === 'serialNumber' || attributes[prop] === 'subform') {
                                if (!values.hasOwnProperty(prop)) {
                                    values[prop] = '';
                                }
                            }
                            if (attributes[prop] === 'subform' && values[prop] && values[prop].length > 0) {
                                values[prop].forEach(v => {
                                    if (!v.subId) {
                                        v.subId = getUUID(8, 16);
                                    }
                                });
                            }
                        }
                    }
                }
                objModelFormData.values = values;
                // ==========解决新增多选组件，历史数据无法使用该组件的问题end===============
                // console.log(objModelFormData);
                this.selectFormData = objModelFormData.values;
            }
        },
        _getModelFormData () {
            let temporaryModelFormData;
            if (this.formInfo.formObj && this.formInfo.formObj.instance) {
                try {
                    let strTemporaryData = this.formInfo.formObj.instance;
                    let objTemporaryData = JSON.parse(strTemporaryData);
                    temporaryModelFormData = objTemporaryData;
                } catch (error) {
                    console.error('解析模型表单数据异常：', error);
                }
            }
            return temporaryModelFormData;
        },
        getAttributes (source) {
            let attributes = {};
            source.forEach(element => {
                let fieldsList = element.fieldsList;
                for (let index = 0, len = fieldsList.length; index < len; index++) {
                    const element = fieldsList[index];
                    attributes[element.id] = element.type;
                }
            });
            return attributes;
        },
        async handleFilterCondition () {
            this.isShowSearchConditon = false;
            if (!this.isRefreshCondition) {
                let columns = cloneDeep(this.tableColumns);
                let idArr = [];
                columns.forEach(item => {
                    idArr.push(item.id);
                });
                this.conditionFields = await getFormFieldListByIds(idArr.join(','));
                // console.log(this.conditionFields);
                this.isRefreshCondition = true;
            }
            this.isShowSearchConditon = true;
        },
        async chooseSearchConditon () {
            this.isShowSearchConditon = false;
            let searchCondition = this.$refs.searchConditon.getSearchCondition();
            // 关联字段查询用-view,否则有些查不到
            if (searchCondition && searchCondition.length > 0) {
                for (let i = 0; i < searchCondition.length; i++) {
                    let cur = searchCondition[i];
                    if (cur.type === 'link') {
                        cur.searchFieldId = cur.id + '-view';
                    }
                }
            }
            // console.log(searchCondition);
            this.page.currentPage = 1; // 分页重置为了1
            this.searchParams.searchCondition = searchCondition;
            this.renderFormList(this.modelObj, true);
        },
        async resetSearchConditon () {
            this.conditionFields.length = 0;
            let columns = cloneDeep(this.tableColumns);
            let idArr = [];
            columns.forEach(item => {
                idArr.push(item.id);
            });
            this.conditionFields = await getFormFieldListByIds(idArr.join(','));
        }
    }
};
</script>

<style lang="less">
</style>


// WEBPACK FOOTER //
// src/components/TableDataPop/TableDataPop.vue